var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdentityDeveloped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 58,
    viewBox: "0 0 74 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018",
    transform: "translate(-407 -20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 74,
    height: 58,
    rx: 6,
    transform: "translate(407 20)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_3_Id_Card",
    transform: "translate(416.058 -25.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015",
    transform: "translate(1.016 52.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3208",
    "data-name": "Path 3208",
    d: "M60.862,116.05v20.744A7.666,7.666,0,0,1,53.2,144.46H16.649a7.666,7.666,0,0,1-7.666-7.666V116.05a7.666,7.666,0,0,1,7.666-7.666H53.2A7.666,7.666,0,0,1,60.862,116.05Z",
    transform: "translate(-8.146 -102.474)",
    fill: "#ebf5fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3209",
    "data-name": "Path 3209",
    d: "M60.838,117.216v20.743a7.664,7.664,0,0,1-7.665,7.665H16.624a7.664,7.664,0,0,1-7.665-7.665v-.845A34.137,34.137,0,0,0,54.6,109.685,7.656,7.656,0,0,1,60.838,117.216Z",
    transform: "translate(-8.125 -103.638)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3210",
    "data-name": "Path 3210",
    d: "M105.64,203.539a5.3,5.3,0,1,1-5.289-5.289A5.3,5.3,0,0,1,105.64,203.539Z",
    transform: "translate(-85.173 -182.903)",
    fill: "#ff896f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3211",
    "data-name": "Path 3211",
    d: "M89.08,306.6H74.086a7.5,7.5,0,0,1,14.994,0Z",
    transform: "translate(-66.413 -273.174)",
    fill: "#ff896f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3212",
    "data-name": "Path 3212",
    d: "M302.415,225.751a2.149,2.149,0,0,1-2.149,2.149h-11.6a2.149,2.149,0,1,1,0-4.3h11.6A2.149,2.149,0,0,1,302.415,225.751Z",
    transform: "translate(-256.535 -205.592)",
    fill: "#acd3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3213",
    "data-name": "Path 3213",
    d: "M296.615,306.3a2.149,2.149,0,0,1-2.149,2.149h-5.8a2.149,2.149,0,1,1,0-4.3h5.8A2.149,2.149,0,0,1,296.615,306.3Z",
    transform: "translate(-256.536 -277.686)",
    fill: "#acd3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3214",
    "data-name": "Path 3214",
    d: "M209.37,60.068v6.277a4.9,4.9,0,0,0,4.9,4.9h0a4.9,4.9,0,0,0,4.9-4.9V60.068Z",
    transform: "translate(-187.49 -59.231)",
    fill: "#1c85e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3215",
    "data-name": "Path 3215",
    d: "M46.066,57.175H33.526V52.938a.837.837,0,0,0-.837-.837H22.9a.837.837,0,0,0-.837.837v4.237H9.519a8.513,8.513,0,0,0-8.5,8.5V86.422a8.513,8.513,0,0,0,8.5,8.5H46.066a8.513,8.513,0,0,0,8.5-8.5V65.678a8.513,8.513,0,0,0-8.5-8.5Zm-22.333-3.4h8.12v5.44a4.06,4.06,0,1,1-8.12,0ZM52.9,86.422a6.837,6.837,0,0,1-6.83,6.829H9.519a6.837,6.837,0,0,1-6.829-6.829V65.678a6.837,6.837,0,0,1,6.829-6.829h12.54v.366a5.733,5.733,0,1,0,11.467,0v-.366h12.54a6.837,6.837,0,0,1,6.83,6.829Z",
    transform: "translate(-1.016 -52.101)",
    fill: "#002245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3216",
    "data-name": "Path 3216",
    d: "M77.772,201.564a6.136,6.136,0,1,0-6.631,0,8.336,8.336,0,0,0-5.022,7.635.837.837,0,0,0,.837.837H81.95a.837.837,0,0,0,.837-.837A8.336,8.336,0,0,0,77.772,201.564Zm-7.778-5.157a4.459,4.459,0,1,1,4.467,4.466,4.464,4.464,0,0,1-4.467-4.466Zm-2.149,11.956a6.662,6.662,0,0,1,13.216,0Z",
    transform: "translate(-59.282 -175.77)",
    fill: "#002245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3217",
    "data-name": "Path 3217",
    d: "M293.135,215.633h-11.6a2.986,2.986,0,0,0,0,5.972h11.6a2.986,2.986,0,1,0,0-5.972Zm0,4.3h-11.6a1.313,1.313,0,0,1,0-2.625h11.6a1.313,1.313,0,1,1,0,2.625Z",
    transform: "translate(-249.406 -198.46)",
    fill: "#002245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3218",
    "data-name": "Path 3218",
    d: "M287.337,296.188h-5.8a2.986,2.986,0,1,0,0,5.972h5.8a2.986,2.986,0,1,0,0-5.972Zm0,4.3h-5.8a1.312,1.312,0,1,1,0-2.625h5.8a1.312,1.312,0,1,1,0,2.625Z",
    transform: "translate(-249.406 -270.556)",
    fill: "#002245"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentityDeveloped);
export default __webpack_public_path__ + "static/media/identityDeveloped.742db651e5e92ecd89a9943b6f40cf53.svg";
export { ForwardRef as ReactComponent };